import { CONSTRUCTION_YEAR_MAP } from '@/components/Filters/ConstructionYear/Store/defaults';
import { DEFAULT_AVAILABLE_CONSTRUCTION_YEARS } from '../defaults';

export function getConstructionYearDescription(
  maxConstructionYear?: string | null,
  minConstructionYear?: string | null,
) {
  let constructionYearName = '';
  const constructionYearKey = getSelectedConstructionYearKey(
    CONSTRUCTION_YEAR_MAP,
    maxConstructionYear,
    minConstructionYear,
  );
  const matchedOption = DEFAULT_AVAILABLE_CONSTRUCTION_YEARS.find((item) => item.value === constructionYearKey);

  if (matchedOption) {
    constructionYearName = `Byggår ${matchedOption.name} ${matchedOption.subName}`;
  } else {
    if (minConstructionYear && maxConstructionYear) {
      constructionYearName = `Byggår ${minConstructionYear}-${maxConstructionYear}`;
    } else if (minConstructionYear) {
      constructionYearName = `Byggår efter ${minConstructionYear}`;
    } else if (maxConstructionYear) {
      constructionYearName = `Byggår före ${maxConstructionYear}`;
    } else {
      constructionYearName = 'Alla byggår';
    }
  }
  return constructionYearName;
}
export const getSelectedConstructionYearKey = (
  map: typeof CONSTRUCTION_YEAR_MAP,
  max?: string | null,
  min?: string | null,
): string | undefined => {
  return Object.entries(map).find(([_, range]) => range.max === max && range.min === min)?.[0];
};
